import z from "zod";
import {
  ProjectIdSchema,
  ProjectSchema,
  ProjectWithInvitesSchema,
  CreateInvitationRequestSchema,
  UpdateInvitationRequestSchema,
  FocusedContextSchema,
  BoundaryIdSchema,
  UserIdSchema,
} from "@storytell/types";

export const ProjectIdParamsSchema = z.object({
  id: z.string(),
});

export const InvitationIdParamsSchema = z.object({
  invitationId: BoundaryIdSchema,
});

export const AcceptInvitationInputSchema = z.object({
  userId: UserIdSchema,
});

export const UpdateInvitationInputSchema = UpdateInvitationRequestSchema;
export type UpdateInvitationInput = z.infer<typeof UpdateInvitationInputSchema>;

// The backend expects just an array of invitations, not wrapped in an object
// The tenancy is obtained from the authentication context on the backend
export const CreateInvitationsInputSchema = z.array(CreateInvitationRequestSchema);
export type CreateInvitationsInput = z.infer<typeof CreateInvitationsInputSchema>;

export const CreateProjectInputSchema = ProjectSchema.pick({
  name: true,
  description: true,
}).extend({
  invites: z.array(CreateInvitationRequestSchema).optional(),
});
export type CreateProjectInput = z.infer<typeof CreateProjectInputSchema>;

export const UpdateProjectInputSchema = ProjectSchema.pick({
  name: true,
  description: true,
});
export type UpdateProjectInput = z.infer<typeof UpdateProjectInputSchema>;

// Sync endpoint returns a map of project IDs to project objects
export const ProjectsSyncSchema = z.object({
  projects: z.record(ProjectIdSchema, ProjectSchema),
});
export type ProjectsSync = z.infer<typeof ProjectsSyncSchema>;
